import apiClient from "../axios";

// Create a local cache to store pricing data
let cachedPricingData = null;
let cachedTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// Pre-fetch data function that can be called early (e.g., on page load or during navigation)
export const prefetchPricingData = () => {
  // Check if cache is valid
  const now = Date.now();
  if (cachedPricingData && cachedTimestamp && (now - cachedTimestamp < CACHE_DURATION)) {
    return Promise.resolve(cachedPricingData);
  }
  
  // Fetch in background if not cached
  return apiClient.get("/billing/plan-list/combinations")
    .then(res => {
      cachedPricingData = res.data;
      cachedTimestamp = now;
      return res.data;
    })
    .catch(error => {
      console.error("Error pre-fetching pricing data:", error);
      return null;
    });
};

// Actual loader function for React Router
export async function load() {
  // Return existing data immediately if available
  const now = Date.now();
  if (cachedPricingData && cachedTimestamp && (now - cachedTimestamp < CACHE_DURATION)) {
    return cachedPricingData;
  }
  
  // Start a fetch but don't wait for it - return a minimal structure immediately
  // This allows navigation to happen instantly
  const emptyData = {
    levels: [],
    themes: [],
    plans: [],
    combinations: [],
    employeeRanges: []
  };
  
  // Start the fetch in the background
  apiClient.get("/billing/plan-list/combinations")
    .then(res => {
      cachedPricingData = res.data;
      cachedTimestamp = now;
    })
    .catch(error => {
      console.error("Error loading pricing data:", error);
    });
  
  // Return immediately with empty data
  return emptyData;
}